import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ProfileOptions.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faWallet,
  faTicket,
  faCircleQuestion,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../../../context/authContext";
import AuthRequiredModal from "../../../../../components/AuthRequiredModal/AuthRequiredModal";
import useRechargeFlow from "../../../../../hooks/useRechargeFlow";

const ProfileOptions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { openRecharge, rechargeModals } = useRechargeFlow();
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { isAuthenticated, user, profile, logout } = useAuth();

  const toggleMenu = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
    } else {
      setIsOpen(!isOpen);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleNavigation = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    setIsOpen(false);
    logout();
    navigate("/welcome");
  };

  const getInitials = () => {
    if (!user) return "";
    const first = user.first_name?.[0] || "";
    const last = user.last_name?.[0] || "";
    return (first + last).toUpperCase();
  };

  const photoUrl =
    profile?.profile_photo_url ||
    profile?.profile_photo ||
    user?.profile_photo_url ||
    user?.profile_photo ||
    "";

  return (
    <>
      <div className={styles.profileOptions} ref={menuRef}>
        <div
          className={`${styles.avatar} ${
            isAuthenticated ? styles.authenticated : ""
          }`}
          onClick={toggleMenu}
        >
          {isAuthenticated && user ? (
            photoUrl ? (
              <img src={photoUrl} alt="" />
            ) : (
              <span className={styles.initials}>{getInitials()}</span>
            )
          ) : (
            <FontAwesomeIcon icon={faUser} className={styles.avatarIcon} />
          )}
        </div>

        {isOpen && isAuthenticated && (
          <div className={styles.profileMenu}>
            <div className={styles.userInfo}>
              <p className={styles.userName}>
                {user?.first_name} {user?.last_name}
              </p>
              <p className={styles.userPhone}>
                {user?.profile?.phone_number || ""}
              </p>
            </div>

            <ul className={styles.profileMenuList}>
              <li onClick={() => handleNavigation("/perfil")}>
                <FontAwesomeIcon icon={faUser} className={styles.menuIcon} />
                Mi perfil
              </li>

              <li
                onClick={() => {
                  setIsOpen(false);
                  navigate("/perfil", { state: { section: "boletos" } });
                }}
              >
                <FontAwesomeIcon icon={faTicket} className={styles.menuIcon} />
                Mis tickets
              </li>

              <li
                onClick={() => {
                  setIsOpen(false);
                  openRecharge();
                }}
              >
                <FontAwesomeIcon icon={faWallet} className={styles.menuIcon} />
                Recargar cuenta
              </li>

              <li onClick={() => handleNavigation("/ayuda")}>
                <FontAwesomeIcon
                  icon={faCircleQuestion}
                  className={styles.menuIcon}
                />
                Ayuda
              </li>
            </ul>

            <button
              type="button"
              className={styles.logoutButton}
              onClick={handleLogout}
            >
              <FontAwesomeIcon
                icon={faSignOutAlt}
                className={styles.menuIcon}
              />
              Cerrar sesión
            </button>
          </div>
        )}
      </div>

      <AuthRequiredModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        message="Para ver tu perfil y acceder a tus opciones de cuenta, necesitas iniciar sesión."
      />

      {rechargeModals}
    </>
  );
};

export default ProfileOptions;
